import ResetPasswordEmailForm from './ResetPasswordEmailForm';

export default ResetPasswordEmailForm;
